const RESOURCES_AR = {
  AIPR: "AIPR",
  BTP_PRO_CARD: "بطاقة BTP الاحترافية",
  CACES: "CACES",
  CE_CERTIFICATE: "شهادة CE",
  CE_CERTIFICATION: "شهادة CE",
  DELIVERY: "تسليم",
  DEPARTURE_NOTE: "إيصال المغادرة",
  DRIVING_AUTHORIZATION: "ترخيص القيادة",
  DUE: "مستحق",
  documentsStatus: "حالة المستندات",
  EMAILS: "البريد الإلكتروني",
  HOUR_SHEET: "سجلات الساعات",
  ICON: "أيقونة",
  ID: "هوية",
  IDENTITY: "هوية",
  INSURANCE: "تأمين",
  INVOICE: "فاتورة",
  KBIS: "كبيس",
  LIFTING_PLAN: "خطة الرفع",
  LIFTING_SHEET: "ورقة الرفع",
  LOGO: "شعار",
  MACHINE_SPECIFICATIONS: "مواصفات الآلة",
  MAINTENANCE_LOG: "سجل الصيانة",
  MAINTENANCE_LOG_EXCERPT: "مقتطف من سجل الصيانة",
  MEDICAL_CERTIFICATE: "شهادة طبية",
  OPERATOR_DOCUMENT: "وثيقة المشغل",
  OTHER: "أخرى",
  PGI: "PGI",
  PHOTO: "صورة",
  PIC: "PIC",
  PURCHASE_ORDER: "أمر شراء",
  QUOTATION: "عرض سعر",
  RETURN_NOTE: "إيصال الإرجاع",
  RIB: "RIB",
  SIGNED_RENTAL_REQUEST: "طلب إيجار موقع",
  SPECIFIC_TRAINING: "تدريب خاص",
  TECHNICAL_SHEET: "ورقة فنية",
  USED_MACHINE_CERTIFICATE: "شهادة آلة مستعملة",
  USER_MANUAL: "دليل المستخدم",
  VGP: "VGP",
  WORK_ORDER: "أمر العمل",
} as const;

export default RESOURCES_AR;
